"use client";

import { IProductTilePriceAndBrandNameXP } from "@faire/web-api/indigofair/data/IProductTilePriceAndBrandNameXP";
import React from "react";

import { useSettingPriceFirstAndNewBrandLink } from "@faire/retailer/settings/useSettingPriceFirstAndNewBrandLink";

export const MaybePriceFirstProductTileWrapper: React.FC<{
  isPriceFirstSlot: boolean;
  children: React.ReactNode;
}> = ({ children, isPriceFirstSlot }) => {
  const priceFirstAndNewBrandLinkOnSearchTile =
    useSettingPriceFirstAndNewBrandLink();

  const showPriceFirst =
    isPriceFirstSlot &&
    priceFirstAndNewBrandLinkOnSearchTile !==
      IProductTilePriceAndBrandNameXP.Bucket.CONTROL;

  const showPriceSecond =
    !isPriceFirstSlot &&
    priceFirstAndNewBrandLinkOnSearchTile ===
      IProductTilePriceAndBrandNameXP.Bucket.CONTROL;

  if (showPriceFirst || showPriceSecond) {
    return <>{children}</>;
  }
  return null;
};
